export default function missions(state = [], action) {
  switch (action.type) {
    default:
      return state
  }
}
